import { useMemo, useState } from "react";
import { ResponsiveImage } from "@/components/ResponsiveImage";
import { projectFilters, projects } from "@/data/siteData";

export const ProjectGrid = ({ featuredOnly = false }) => {
  const [filter, setFilter] = useState("all");
  const visible = useMemo(() => {
    const source = featuredOnly ? projects.filter((project) => project.supplied) : projects;
    return filter === "all" ? source : source.filter((project) => project.category === filter);
  }, [filter, featuredOnly]);
  return (
    <div>
      {!featuredOnly && (
        <div className="project-filters" data-testid="project-filter-group">
          {projectFilters.map(([id, label]) => <button type="button" key={id} className={filter === id ? "is-active" : ""} onClick={() => setFilter(id)} data-testid={`project-filter-${id}`}>{label}</button>)}
        </div>
      )}
      <div className={`project-grid ${featuredOnly ? "project-grid-featured" : ""}`} data-testid="project-grid">
        {visible.map((project, index) => (
          <article className="project-card" key={project.id} data-testid={`project-card-${project.id}`}>
            <div className="project-image">
              <ResponsiveImage slug={project.image} alt={project.title} sizes="(max-width: 760px) 100vw, (max-width: 1100px) 50vw, 33vw" testId={`project-image-${project.id}`} eager={featuredOnly && index < 2} />
              <span className={project.supplied ? "work-label" : "reference-label"}>{project.supplied ? "Suha Builders work" : "Sector reference"}</span>
            </div>
            <div className="project-copy"><span>{project.meta}</span><h3>{project.title}</h3></div>
          </article>
        ))}
      </div>
    </div>
  );
};
